<template>
  <el-dialog title="导入商品货位关联关系" :visible.sync="dialogVisible" width="800px" @closed="handleFileClose">
    <!-- 隐藏的文件上传input -->
    <input type="file" ref="fileInput" style="display: none" @change="handleFileChange" accept=".xls,.xlsx">
    <input id="fileupload" type="file" @change="importFile"
      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      style="display:none" title="1" />

    <!-- 第一行按钮组 -->
    <div class="button-group">
      <div class="left-buttons">
        <el-button type="primary" size="small" @click="downloadTemplate">点击下载模板</el-button>
        <el-button size="small" @click="uploadinfos" :loading="uploading" :disabled="uploading">上传模板</el-button>
      </div>
      <div class="right-buttons">
        <el-button size="small" @click="dialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmit">提交</el-button>
      </div>
    </div>

    <!-- 第二行提示文字 -->
    <div class="tip-text">
      温馨提示：单次导入不超过500条数据
    </div>

    <!-- 第三行表格 -->
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="basebarcode" label="商品条码" />
      <el-table-column prop="full_code" label="货位码" />
    </el-table>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="handleSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false,
      url: `${this.GLOBAL.domain}Inventory/index`,
      tableData: [],
      uploading: false,
      formData: null
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },

    // 下载模板
    downloadTemplate() {
      const url = new URL(`${this.GLOBAL.domain}Inventory/index?act=down_load_inventory&token=${this.$cookies.get('token')}`);
      const link = document.createElement('a');
      link.href = url.toString();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    /** 导入文件 **/
    uploadinfos() {
      document.getElementById("fileupload").click();
    },

    // 文件选择处理
    handleFileChange(e) {
      const file = e.target.files[0]
      if (!file) return

      // 文件类型验证
      const isExcel = /\.(xls|xlsx)$/i.test(file.name)
      if (!isExcel) {
        this.$message.error('只能上传Excel文件!')
        return
      }

      // 文件大小限制（这里限制50MB）
      if (file.size > 50 * 1024 * 1024) {
        this.$message.error('文件大小不能超过50MB!')
        return
      }
      this.importfile(file)
    },
    importFile(event) {
      // 通过DOM取文件数据
      var file = event.target.files[0];

      if (!file) return;

      const formData = new FormData();
      formData.append('import', file);
      formData.append('act', 'upload_inventory');
      formData.append('token', this.$cookies.get('token'));

      // 清空输入框的文件值，避免下次change事件失效
      document.getElementById('fileupload').value = null;
      this.uploadgoodsLoading = true;

      var resource = this.$resource(this.url);
      resource.save(formData).then((res) => {
        const resData = JSON.parse(Base64.decode(res.data.Data));
        console.log(resData, '上传文件')
        if (resData.err_msg) {
          this.$message.error(resData.err_msg);
          return
        }
        if (res.data.Result > 0) {
          if (res.data.Result == '70001') this.$router.push('/login')
          if (res.data.Result == 12) {
            this.$message.error(res.data.Message);
          }
        } else {
          this.tableData = resData;
        }
      }).finally(() => {
        this.uploadgoodsLoading = false;
      })
    },

    async handleSubmit() {
      if (this.tableData.length === 0) {
        this.$message.warning('请先上传数据')
        return
      }

      // 这里添加实际提交逻辑
      console.log('提交数据', this.tableData)
      try {
        const res = await this.$axios({
          url: this.url,
          method: 'post',
          data: {
            act: 'submit_inventory',
            json_data: JSON.stringify(this.tableData)
          }
        })
        // var result = JSON.parse(Base64.decode(res.Data));
        console.log(res, 'REsulee')
        if (res.Data && res.Data.err_msg) {
          this.$message.error(res.Data.err_msg)
        } else if (res.Result === 0 && res.Message === 'ok') {
          this.$message.success('关联操作成功！')
          this.$emit('upload')
          this.dialogVisible = false
        }

      } catch (err) {
        console.log(err)
      }

    },
    handleFileClose() {
      this.tableData = []
    }
  }
}
</script>

<style scoped>
.button-group {
  display: flex;
  justify-content: space-between;
}

.tip-text {
  color: red;
  font-size: 12px;
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/inventory/inventoryListImportDiaolog.vue